<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options"
                 text-field="label" value-field="value">
  </b-form-select>
</template>

<script>
  export default {
    name: 'record-select',
    props: {
      'datasetId': {required: true},
      'value': {required: true},
      'labelFn': {require: false}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      columns () {
        return this.$store.getters.datasetColumns(this.datasetId)
      },
      options () {
        return [{label: '', value: null}].concat(
          this.$store.getters.datasetRecords(this.datasetId)
            .map(each => {
              return {
                label: this.mapLabel(each),
                value: each.recordId
              }
            })
        )
      }
    },
    watch: {
      value: function (val) {
        this.localValue = val
      },
      localValue: function (val) {
        this.$emit('input', val)
      }
    },
    methods: {
      mapLabel (record) {
        if (this.labelFn && typeof this.labelFn === 'function') {
          return this.labelFn(record)
        }
        const result = []
        for (let k of this.columns) {
          if (!record.hasOwnProperty(k)) continue
          result.push(record[k])
        }
        return result.join(', ')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/record-select.vue